import { Box, SxProps, Typography } from '@mui/material';
import * as React from 'react';

interface ErrorMessageProps {
  message?: string;
  sx?: SxProps;
}

export default function ErrorMessage({
  message,
  sx
}: ErrorMessageProps): React.ReactElement {
  return (
    <Box sx={{ wordWrap: 'break-word', overflowWrap: 'break-word', ...sx }}>
      {message && (
        <Typography color='error' variant='body2' sx={{ whiteSpace: 'normal' }}>
          {message}
        </Typography>
      )}
    </Box>
  );
}
